import { render, staticRenderFns } from "./AppBarTab.vue?vue&type=template&id=13b5ae20"
import script from "./AppBarTab.vue?vue&type=script&lang=js"
export * from "./AppBarTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports